import React, { useMemo } from "react";
import styled from "@emotion/styled";
import { useIntl } from "react-intl";

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    minHeight: "120px",
    backgroundColor: "white",
    position: "relative",
  },
  firstContainer: {
    maxWidth: "152px",
    flex: 1,
  },
  rightBorder: {
    borderRight: "1px solid rgba(0,0,0, .05)",
  },
  otherContainer: {
    flex: 1,
    borderRight: "1px solid rgba(0,0,0, .05)",
  },
  lastContainer: {
    flex: 1,
  },
};

const Header = styled.div`
  width: 100%;
  height: 8px;
  background-color: ${(props: { backgroundColor?: string }) =>
    props?.backgroundColor || "blue"};
`;
const UnavailableContainer = styled.div`
  -ms-transform: rotate(-10deg);
  transform: rotate(-10deg);
`;

const DisabledOverlay = styled.div`
  margin-left: ${(props: { order?: string }) =>
    props.order === "first" || props.order === "first-circular"
      ? "-12px"
      : "0px"};
  width: ${(props: { order?: string }) =>
    props.order === "first" || props.order === "first-circular"
      ? "calc(100% + 12px)"
      : "100%"};
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: black;
  z-index: 10;
  opacity: 0.6;
  display: flex;
  color: rgba(255, 255, 255, 0.7);
  align-items: center;
  justify-content: center;
`;

const Content = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-right: 0px;
`;

type Props = {
  order?: string;
  numberOfSection?: number;
  disabled?: boolean;
  children?: React.ReactNode;
  headerColor?: string;
  style?: {};
};

function StatsContainer({
  order,
  disabled,
  children,
  headerColor,
  numberOfSection,
  style,
}: Props): JSX.Element {
  const { formatMessage } = useIntl();

  const containerStyle = useMemo(() => {
    if (order === "first" && numberOfSection === 2) {
      return styles.firstContainer;
    }

    switch (order) {
      case "first":
        return { ...styles.firstContainer, ...styles.rightBorder };
      case "last":
        return styles.lastContainer;
      default:
        return styles.otherContainer;
    }
  }, [numberOfSection, order]);

  return (
    <div
      // @ts-ignore
      style={{
        ...styles.container,
        ...containerStyle,
        ...(style || {}),
      }}
    >
      {disabled && (
        <DisabledOverlay order={order}>
          <UnavailableContainer>
            {formatMessage({ id: "toast.info.unavailable" })}
          </UnavailableContainer>
        </DisabledOverlay>
      )}
      {headerColor && <Header backgroundColor={headerColor} />}
      <Content>{children}</Content>
    </div>
  );
}

export default StatsContainer;
